import axios from "axios";

import API_URL from "../../../redux2";

export const getAmadeusPricing = async (data) => {
  try {
    const response = await axios.post(API_URL + "/amadeus/price", data);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const AmadeusAirBooking = async (data, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.post(API_URL + "/amadeus/book", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return {
      error: error.response.data,
    };
  } finally {
    setLoading(false);
  }
};

export const issueAmadeusTicket = async (data, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.post(API_URL + "/amadeus/issue-ticket", data);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  } finally {
    setLoading(false);
  }
};

export const retrieveAmadeusTicket = async (flight, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.get(
      API_URL +
        `amadeus/order-retrieve/${flight.providerPnr}/${flight.orderItems[0]}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

export const voidAmadeusTicket = async (data, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.delete(
      API_URL + `/amadeus/order-void/${data.orderId}/${data.amaClientRef}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

export const cancelAmadeusTicket = async (data, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.delete(
      API_URL + `/amadeus/order-cancel/${data.orderId}/${data.amaClientRef}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};
